import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { style: {"width":"50%","min-width":"829px"} }

import {ref, onActivated, reactive, onMounted} from 'vue';
import dayjs from "dayjs"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    translatorList:{
        default:[]
    },
    orgList:{
        default:[]
    }
},
  setup(__props) {

const props = __props

let {
    // 译员效率值查询
    'POST/efficiency/translator':translatorEffApi
}=Api

const tableHeight=window.innerHeight-200
let defaultMonth=[dayjs(new Date().setMonth(new Date().getMonth()-1)).startOf("month").format("YYYY-MM-DD"),dayjs(new Date().setMonth(new Date().getMonth()-1)).startOf("month").format("YYYY-MM-DD")]
const queryForm=ref<any>({
    monthRange:defaultMonth
})
const translatorEffList=ref([])
const listLoading=ref(false)
const sortType=ref("")
const average=ref("") //总计平均值
const tableRef=ref()
const getTrabslatorEff=(isReset:boolean=false)=>{
    if(isReset){
        queryForm.value={monthRange:defaultMonth}
        sortType.value=""
        queryForm.value.showNoWords=false
        tableRef.value.clearSort()    
    }
    let {userIds,monthRange,orgIds,showNoWords}=queryForm.value
    let params={
        userIds:userIds||[],
        orgIds:orgIds||[],
        monthFrom:monthRange&&monthRange.length?dayjs(monthRange[0]).format("YYYY-MM-DD"):'',
        monthTo:monthRange&&monthRange.length?dayjs(monthRange[1]).format("YYYY-MM-DD"):'',
        sort:sortType.value,
        showNoWords:showNoWords||false
    }
    listLoading.value=true
    translatorEffApi(params).then((res:any)=>{
        translatorEffList.value=res.data
        average.value=res.average
        listLoading.value=false
    }).catch(()=>{
        listLoading.value=false
    })
}
const sortChange=({column, prop, order}:any)=>{
    sortType.value=order?order=='ascending'?'ASC':'DESC':''
    getTrabslatorEff()
}
const getSummaries=(param:any)=>{
   const { columns, data } = param;
      let sums:any = [];
      columns.forEach((column:any, index:any) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        } else if (column.property == "efficiency") {

          const values = data.map((item:any) => Number(item[column.property]));
          if (!values.every((value:any) => isNaN(value))) {
            sums[index] = average.value
          }
        }
      });
      return sums;
}

onMounted(()=>{
    getTrabslatorEff()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchBg",
              style: {"padding-top":"26px"},
              inline: true,
              model: queryForm.value,
              "label-width": "50px",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"260px"},
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      modelValue: queryForm.value.userIds,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.userIds) = $event)),
                      filterable: "",
                      multiple: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.translatorList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.realName+`(${item.alias})`,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"260px"},
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      modelValue: queryForm.value.orgIds,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.orgIds) = $event)),
                      filterable: "",
                      multiple: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "日期:",
                  prop: "month"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      type: "monthrange",
                      "range-separator": "To",
                      "start-placeholder": "",
                      "end-placeholder": "",
                      modelValue: queryForm.value.monthRange,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.monthRange) = $event)),
                      clearable: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "显示已字数为0译员:",
                  prop: "showNoWords",
                  "label-width": "145"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      onChange: _cache[3] || (_cache[3] = ()=> getTrabslatorEff()),
                      modelValue: queryForm.value.showNoWords,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.showNoWords) = $event)),
                      label: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (getTrabslatorEff()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (getTrabslatorEff(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        onSortChange: sortChange,
        "summary-method": getSummaries,
        "show-summary": "",
        border: "",
        "max-height": tableHeight+'px',
        data: translatorEffList.value,
        class: "mt-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "中文名",
            prop: "realName"
          }),
          _createVNode(_component_el_table_column, {
            label: "英文名",
            prop: "alias"
          }),
          _createVNode(_component_el_table_column, {
            label: "团队",
            prop: "orgName"
          }),
          _createVNode(_component_el_table_column, {
            label: "效率值(薪酬/字数)",
            sortable: "custom",
            prop: "efficiency",
            align: "right"
          })
        ]),
        _: 1
      }, 8, ["max-height", "data"])), [
        [_directive_loading, listLoading.value]
      ])
    ])
  ]))
}
}

})